'use strict';

import './employeeDataAdapter.scss';
import template from './employeeDataAdapter.template.html';
import controller from './employeeDataAdapter.controller.js';

const component = {
    bindings: {
        customerId: '@',
        customerSlug: '@',
        position: '@',
        showSpcAlternate: '<',
        modalId: '@'
    },
    controller,
    template
};

export default component;